import { Outlet } from 'react-router-dom'

import { Sidebar } from './sidebar'

export function Layout (): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        minHeight: '100vh'
      }}
    >
      {/* <NavBar /> */}

      <div style={{ position: 'relative', width: '100%' }}>
        <Outlet />
      </div>
      <Sidebar />
    </div>
  )
}
